import React from 'react';
import LegalPage, { Section, Link } from '@/components/Pages/LegalPage';
import Paragraph from '@/components/Typography/Paragraph';
import MetaHead from '@/components/MetaHead';
import agreement from '@/constants/legal/affiliate-program-agreement.json';

export default function AffiliateProgramAgreement() {
  return <LegalPage title={agreement.title} lastUpdated={agreement.updated}>
    <MetaHead title={agreement.title} description="Gab AI affiliate eligibility, commissions, promotion standards and termination terms." canonical="/affiliate-program-agreement" />
    <Paragraph>Version {agreement.version}. Your individual offer and this agreement must be accepted in your affiliate settings before participation.</Paragraph>
    <Link href="/terms-of-service">Gab AI Terms of Service</Link>
    <Link href="/privacy-policy">Privacy Policy</Link>
    {agreement.sections.map(section => <Section key={section.title} title={section.title}><Paragraph>{section.text}</Paragraph></Section>)}
  </LegalPage>;
}
